import Main from './Main'
import Lista from './components/ContaBancaria'
import Novo from './components/NovoContaBancaria'

export default [
  {
    path: 'conta-bancaria',
    name: 'config.conta.bancaria',
    component: Main,
    redirect: { name: 'config.conta.bancaria.list' },
    children: [
      {
        path: '/',
        name: 'config.conta.bancaria.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'config.conta.bancaria.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'config.conta.bancaria.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/configuracoes/conta-bancaria/routes.js